import { combineReducers } from "redux";
import { AnyAction, Reducer } from "@reduxjs/toolkit";
import authReducer from "./auth";
import accountReducer from "./account";
import signInReducer from "./signIn";
import splashReducer from "./splash";
import loadingReducer from "./loading";
import favoriteToursReducer from "./favoriteTours";
import externalDataReducer from "./externalData";
import searchCategoriesReducer from "./searchCategories";
import searchToursReducer from "./searchTours";
import tourReducer from "./tour";
import redeemerReducer from "./redeemer";
import allQuotesReducer from "./allQuotes";
import myQuotesReducer from "./myQuotes";
import bookNowReducer from "./bookNow";
import statusAppReducer from "./statusApp";
import savedCartReducer from "./savedCarts";
import bookingReducer from "./booking";
import toastReducer from "./toast";
import agentReducer from "./agent";
import toursCategoryReducer from "./toursCategory";
import homePageProductReducer from "./homePageProduct";
import locationSearchReducer from "./locationSearch";
import { checkoutReducer } from "@module";
import beaconReducer from "./beacon";
import pointsReducer from "./points";
import tripPlannerReducer from "./tripPlanner";
import cmsReducer from "./cms";

export * from "./auth";
export * from "./account";
export * from "./signIn";
export * from "./splash";
export * from "./loading";
export * from "./externalData";
export * from "./favoriteTours";
export * from "./searchCategories";
export * from "./searchTours";
export * from "./tour";
export * from "./redeemer";
export * from "./bookNow";
export * from "./savedCarts";
export * from "./statusApp";
export * from "./booking";
export * from "./toast";
export * from "./agent";
export * from "./toursCategory";
export * from "./homePageProduct";
export * from "./locationSearch";
export * from "./beacon";
export * from "./points";
export * from "./tripPlanner";
export * from "./cms";

const appReducer = combineReducers({
    auth: authReducer,
    account: accountReducer,
    checkout: checkoutReducer,
    signIn: signInReducer,
    splash: splashReducer,
    loading: loadingReducer,
    favoriteTours: favoriteToursReducer,
    externalData: externalDataReducer,
    searchCategories: searchCategoriesReducer,
    searchTours: searchToursReducer,
    tour: tourReducer,
    redeemer: redeemerReducer,
    allQuotes: allQuotesReducer,
    myQuotes: myQuotesReducer,
    bookNow: bookNowReducer,
    status: statusAppReducer,
    savedCart: savedCartReducer,
    booking: bookingReducer,
    toast: toastReducer,
    agent: agentReducer,
    toursCategory: toursCategoryReducer,
    homePageProduct: homePageProductReducer,
    locationSearch: locationSearchReducer,
    beacon: beaconReducer,
    points: pointsReducer,
    tripPlanner: tripPlannerReducer,
    cms: cmsReducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
    if (action.type === "RESET") {
        // reset state
        state = {} as RootState;
        // reset local storage
        localStorage.clear();
    }
    return appReducer(state, action);
};

export const selectCheckout = (state: RootState) => state.checkout;
export default rootReducer;
